<p-toast></p-toast>
<p-dialog [(visible)]="mediaModal" header="Enviar imagen" [breakpoints]="{'960px': '75vw', '640px': '100vw'}"
    [style]="{'width': '50vw'}">
    <app-uploadmedia (imageUploaded)="onImageUploaded()"></app-uploadmedia>
</p-dialog>

<p-dialog [(visible)]="contactModal" header="Compartir contacto" [breakpoints]="{'960px': '75vw', '640px': '100vw'}"
    [style]="{'width': '50vw'}">
    <app-share-cont-comp></app-share-cont-comp>
</p-dialog>

<div class="p-grid">
    <!-- // TODO: Barra de asignar a: -->
    <div class="p-col-12 p-md-12 p-lg-12 customBGC ns" #barraContainer>
        <br />
        <div class="custom-span">
            <span *ngIf="selectedChat || datos">{{ 'MESSAGE_SCRREN_STATUS' | translate}}</span>
        </div>
        <select *ngIf="selectedChat || datos" class="custom-select" [(ngModel)]="estatusMostrarSelect"
            (change)="onStatusChange($event)">
            <option hidden disabled [value]="null">{{ 'MESSAGE_SCRREN_STATUS_OPTION' | translate}}</option>
            <option [value]="item.idStatus" *ngFor="let item of estatus">{{item.name}}</option>
        </select>
        <div class="custom-span-2">
            <span *ngIf="idrol === 1 && selectedChat || idrol ===2 && selectedChat
            || idrol === 1 && datos || idrol ===2 && datos">{{ 'MESSAGE_SCRREN_ASSIGN_CHAT' | translate}}</span>
        </div>

        <select [(ngModel)]="showUser" *ngIf="idrol === 1 && selectedChat || idrol ===2 && selectedChat
        || idrol === 1 && datos || idrol ===2 && datos" label="Asignar chat a:" icon="pi pi-user"
            (change)="changeUser($event)" class="custom-select-asignar">
            <option hidden disabled [value]="null">{{ 'MESSAGE_SCRREN_STATUS_OPTION' | translate}}</option>
            <option hidden disabled [value]="0">Asignado a mi</option>
            <ng-container *ngFor="let user of usuarios">

                <option [value]="user.idUser" *ngIf="idrol === 1 || idrol ===2">{{ user.label }}</option>
            </ng-container>
        </select>

        <div class="custom-span">
            <span *ngIf="selectedChat || datos">{{ 'MESSAGE_SCRREN_CONTACT' | translate}}</span>
        </div>
        <div class="edit-container" *ngIf="selectedChat || datos">
            <button pButton type="button" class="p-button-rounded custom-edit-button" (click)="toggleEdit()">
                <i class="pi pi-pencil custom-edit-icon"></i>
            </button>
            <div class="input-container">
                <input *ngIf="datos" [(ngModel)]="contactNameNew" [class.editable-input]="isEditingName"
                    [class.editing]="isEditingName" [readonly]="!isEditingName"
                    style="background-color: #a1a2a5; padding: .2rem; color: whitesmoke; border-radius: .3rem; margin: 3px;"
                    (keydown.enter)="editContactName()" />
                <span *ngIf="isEditingName && datos">{{ 'MESSAGE_SCRREN_ENTER_SAVE' | translate}}</span>
                <input *ngIf="!datos && selectedChat" [(ngModel)]="contactName" [class.editable-input]="isEditingName"
                    [class.editing]="isEditingName" [readonly]="!isEditingName"
                    style="background-color: #a1a2a5; padding: .2rem; color: whitesmoke; border-radius: .3rem; margin: 3px;"
                    (keydown.enter)="editContactName()" />
                <span *ngIf="isEditingName && selectedChat">{{ 'MESSAGE_SCRREN_ENTER_SAVE' | translate}}</span>
            </div>
        </div>

        <p-button type="button" class="p-mr-2 fR button-align fixed-button" (click)="sendRB()"
            icon="pi pi-arrow-left"></p-button>

    </div>

    <div class="p-col-12 p-md-12 p-lg-12 customBGC sh">
        <br />
        <p-splitButton icon="pi pi-check" [model]="items" styleClass="p-button-success"
            [style]="{'margin':'12px 15px 10px 20px !important'}">
        </p-splitButton>
        <p-splitButton icon="pi pi-users" [model]="usuarios" styleClass="p-button-secondary p-button-text"
            [style]="{'margin':'12px 15px 10px 20px !important'}">
        </p-splitButton>

        <p-button type="button" class="p-mr-2 fR" (click)="sendRB()" icon="pi pi-arrow-left"></p-button>
    </div>

    <!-- // TODO: Mensajes de conversación -->
    <!-- NGSTYLE ANTERIOR [ngStyle]="{'max-height': 'calc('+ht+'px *'+ perv+')', 'min-height': 'calc('+ht+'px *'+ perv+')' }" -->
    <div class="p-col-12 p-md-12 p-lg-12 chatArea" #messagesContainer *ngIf="selectedChat || datos"
        [ngStyle]="{'max-height': ht+'px', 'min-height': ht+'px' }" (scroll)="onScroll()">
        <div *ngIf="loadingMessages" class="loading-indicator">
            <p-progressSpinner [style]="{'width':'40px', 'height':'40px'}"></p-progressSpinner>
            <p [style]="{'width':'40px', 'height':'40px'}"> {{ 'MESSAGE_SCRREN_LOADING_MESSAGES' | translate}} </p>
        </div>

        <div class="row pd-15" *ngFor="let msg of dataMessages.slice().reverse(); trackBy: trackByFn"
             [class.highlighted]="msg === highlightedMessage" [class.clear-highlight]="highlightedMessage === null">

            <ng-container *ngIf="selectedChat || datos">
                <div class="p-grid">
                    <div class="p-col-12">
                        <div class="admiMsg" *ngIf="msg.message && mostrarTextoMarcado && msg.isOutPut ">
                            <div  [innerHTML]="highlightSearchTerm(msg.message? msg.message : null, searchTerm)">
                            </div>
                            <span class="fR">{{msg.date}}</span>
                        </div>
                        <div class="clientMsg" *ngIf="msg.message && mostrarTextoMarcado && !msg.isOutPut">
                            <div  [innerHTML]="highlightSearchTerm(msg.message? msg.message : null, searchTerm)">
                            </div>
                            <span class="fR">{{msg.date}}</span>
                        </div>
                       
                        <div *ngIf="msg.message && !mostrarTextoMarcado" [ngClass]="{'admiMsg': msg.isOutPut, 'clientMsg': !msg.isOutPut,
                        }">

                        {{( !mostrarTextoMarcado && !msg.isFile && !msg.urlLocation && !msg.isDocument ? msg.message : '')}}
                        <br />

                            <a *ngIf="msg.isFile" [href]="msg.message" target="_blank">
                                <img [src]="msg.message" alt="">
                            </a>

                            <a *ngIf="msg.urlLocation && !msg.isFile" [href]="msg.urlLocation" target="_blank">
                                <div class="link-preview">
                                    <span >{{msg.message}}</span>
                                </div>
                            </a>

                            <ngx-doc-viewer *ngIf="msg.isDocument && !msg.isFile && !msg.urlLocation"
                                style="height: 150px;" [url]="msg.message"></ngx-doc-viewer>
                            <button class="button-document" *ngIf="msg.isDocument && !msg.isFile && !msg.urlLocation"
                                (click)="verDocumento(msg.message)">{{ 'MESSAGE_SCRREN_VIEW_DOCUMENT' | translate}}</button>

                            <span class="fR">{{msg.date}}</span>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
        <div id="scrollId"></div>
        <!-- <div *ngIf="loadingMessages" class="loading-indicator">
            <p-progressSpinner [style]="{'width':'40px', 'height':'40px'}"></p-progressSpinner>
            <p [style]="{'width':'40px', 'height':'40px'}"> Cargando mensajes... </p>
        </div>
        
        <div class="row pd-15" *ngFor="let msg of dataMessages.slice().reverse(); trackBy: trackByFn"
            [class.highlighted]="msg === highlightedMessage" [class.clear-highlight]="highlightedMessage === null">

            <ng-container *ngIf="selectedChat|| datos">

                <div class="p-grid">
                    <div class="p-col-12">
                        <div *ngIf="msg.isOutPut === true && msg.isFile === true" class="admiMsg"><br />
                            <a [href]="msg.message" target="_blank">
                                <img [src]="msg.message" alt="">
                            </a>
                            <span class="fR">{{msg.date}}</span>
                        </div>
                        <div *ngIf="msg.isOutPut === true && msg.urlLocation && !msg.isFile" class="admiMsg">
                            <br />
                            <a [href]="msg.urlLocation" target="_blank">
                                <div class="link-preview">
                                    <span>{{msg.message}}</span>
                                </div>
                            </a>
                            <span class="fR">{{msg.date}}</span>
                        </div>
                        <div *ngIf="msg.isOutPut === true && msg.isDocument === true && !msg.isFile && !msg.urlLocation" class="admiMsg">
                            <br />
                            <ngx-doc-viewer *ngIf="msg.message" style="height: 150px;" [url]="msg.message"></ngx-doc-viewer>
                        
                            <button class="button-document" *ngIf="msg.message" (click)="verDocumento(msg.message)">Ver documento</button>
                            <span class="fR">{{msg.date}}</span>
                        </div>
                        <div *ngIf="msg.isOutPut === true && !msg.isFile && !msg.urlLocation && !msg.isDocument 
                        && msg.message !== ''" class="admiMsg">{{msg.message}}<br />
                            <span class="fR">{{msg.date}}</span>
                        </div>
                        <div *ngIf="msg.isOutPut === false && msg.isFile === true" class="clientMsg">
                            <a [href]="msg.message" target="_blank">
                                <img [src]="msg.message" alt="">
                            </a>
                            <span class="fR">{{msg.date}}</span>
                        </div>
                        <div *ngIf="msg.isOutPut === false && msg.urlLocation && !msg.isFile" class="clientMsg">
                            <br />
                            <a [href]="msg.urlLocation" target="_blank">
                                 <div class="link-preview">
                                    <span>{{msg.message}}</span>
                                </div>
                            </a>
                            <span class="fR">{{msg.date}}</span>
                        </div>
                        <div *ngIf="msg.isOutPut === false && msg.isDocument === false && !msg.isFile && !msg.urlLocation" class="clientMsg">
                            <br />
                            <a [href]="msg.message" target="_blank"> 
                                 <div class="link-preview">
                                    <span>{{msg.message}}</span>
                                </div>
                            </a>
                            <span class="fR">{{msg.date}}</span>
                        </div>
                        <div *ngIf="msg.isOutPut === false && !msg.isFile" class="clientMsg">{{msg.message}}<br />
                            <span class="fR">{{msg.date}}</span>
                        </div>

                    </div>
                </div>
            </ng-container>
            
        </div>
        <div id="scrollId"></div>  -->
    </div>



        <div *ngIf="showMap" class="map-container">
            <div class="map-frame">
                <div id="map"></div>
            </div>
        </div>


        <!-- // TODO: Apartado para responder mensajes -->
        <div *ngIf="selectedChat || datos" class="p-col-12 p-md-12 p-lg-12" #responderContainer
            [style]="{'position': 'fixed', 'bottom': '0%','padding': '0px', 'height': '220px'}">

            <p-tabView [(activeIndex)]="activeTab">
                <p-tabPanel>
                    <ng-template pTemplate="header">
                        <h5>{{ 'MESSAGE_SCRREN_REPLY' | translate}}</h5>
                    </ng-template>
                    <textarea [(ngModel)]="newMsg" [rows]="2" [cols]="30" pInputTextarea [autoResize]="true"
                        placeholder="{{ 'MESSAGE_SCRREN_WRITE_MESSAGE' | translate}}" class="txtCustom" (input)="checkEmptyMessage()">
            </textarea>
                    <i class="pi pi-send custImg" (click)="sendMessageOrImage()" 
                    [ngClass]="{ 'disabled': 
                 
                 sendingMessage || sinContenido}"></i>
                    <br />
                    <br />
                    <div class="button-container">
                        <img src="https://img.icons8.com/material-outlined/24/000000/image.png" class="custIcon"
                            pTooltip="{{ 'MESSAGE_SCRREN_SEND_IMAGE' | translate}}" (click)="fileInput.click()" tooltipPosition="top" />
                        <input id="fileInput" type="file" accept="image/*" #fileInput style="display: none;"
                            (change)="onFileSelected($event)" />


                        <img src="https://img.icons8.com/ios-glyphs/24/000000/file--v1.png" class="custIcon"
                            pTooltip="{{ 'MESSAGE_SCRREN_SEND_DOCUMENT' | translate}}" (click)="documentInput.click()" tooltipPosition="top" />
                        <input id="documentInput" type="file" accept=".pdf, .doc, .docx, .txt" #documentInput
                            style="display: none;" (change)="onDocumentSelected($event)" />

                        <emoji-mart class="emoji-mart custPos" *ngIf="showEmojiPicker" (emojiSelect)="addEmoji($event)"
                            title="Seleccione sus emojis...">
                        </emoji-mart>


                        <!-- Botón para abrir el mapa -->
                        <!-- <button pButton type="button" class="custIcon" name="location" (click)="toggleMap()"
                    pTooltip="Enviar ubicación" tooltipPosition="top"></button> -->
                        <img *ngIf="!showMap" src="https://img.icons8.com/material-outlined/24/000000/map-marker.png
                    " class="custIcon" (click)="showInputsLocation()" pTooltip="{{ 'MESSAGE_SCRREN_SEND_LOCATION' | translate}}"
                            tooltipPosition="top" />
                        <!-- <img *ngIf="!showMap" src="https://img.icons8.com/material-outlined/24/000000/map-marker.png
                    " class="custIcon" (click)="toggleMap()" pTooltip="Enviar ubicacion" tooltipPosition="top"/> -->
                        <button *ngIf="showMap" (click)="closeMap()"
                            style="color: red; border: none; cursor: pointer; font-size: 20px;">❌</button>


                        <!-- <div id="map" style="height: 200px; width: 200px; position: absolute; top: 0; left: 0; z-index: 999;"></div> -->
                        <!-- <img src="/src/assets/marker.png" class="custIcon" pTooltip="Enviar ubicación" (click)="selectLocation()" tooltipPosition="top" />
                 -->
                        <img *ngIf="!showEmojiPicker"
                            src="https://img.icons8.com/material-outlined/24/000000/smiling.png" class="custIcon"
                            name="emo" (click)="toggleEmojiPicker()" pTooltip="{{ 'MESSAGE_SCRREN_SEND_EMOJIS' | translate}}" tooltipPosition="top" />
                        <button *ngIf="showEmojiPicker" (click)="toggleEmojiPicker()"
                            style="color: red; border: none; cursor: pointer; font-size: 20px;">❌</button>
                        <div *ngIf="isImageSelected" class="selected-image-preview">
                            <img style="width: 45px; height: 45px;" [src]="selectedImageUrl" alt="Selected Image" />
                            <span (click)="clearImageSelection()" style="cursor: pointer;"
                                class="clear-selection-button">X</span>
                        </div>

                        <div *ngIf="isFileSelected" class="selected-image-preview">
                            <span>{{selectedDocumentName}}</span>
                            <span (click)="clearFileSelection()" style="cursor: pointer;"
                                class="clear-selection-button">X</span>
                        </div>

                    </div>

                </p-tabPanel>
                <p-tabPanel [style]="{marginLeft:'5rem'}">
                    <ng-template pTemplate="header">
                        <h5 [style]="{'color':'red'}">{{ 'MESSAGE_SCRREN_NOTE' | translate}}</h5>
                    </ng-template>
                    <ng-template pTemplate="content">
                        <textarea [(ngModel)]="newNote" [rows]="2" [cols]="35" pInputTextarea [autoResize]="true"
                            placeholder="{{ 'MESSAGE_SCRREN_WRITE_NOTE' | translate}}" class="txtCustom">
                    </textarea><i (click)="sendNote()" class="pi pi-send custImg"
                            [ngClass]="{ 'disabled': newNote === '' }"></i>
                    </ng-template>
                </p-tabPanel>
            </p-tabView>
        </div>
</div>


<div *ngIf="showInputs" class="modal-overlay">
    <div class="modal">
        <div class="modal-header">
            <button class="close-button" (click)="showInputsLocation()">X</button>
        </div>
        <div style="margin-top: 10px;">
            <p>{{ 'MESSAGE_SCRREN_DESCRIPTION_LOCATION' | translate}}</p>
            <span class="redirection-label" (click)="redirectToURL()">{{ 'MESSAGE_SCRREN_GENERATE' | translate}}</span>
        </div>
        <div class="input-group">
            <div class="input-row">
                <label  style="margin-right: 3px;" for="latitud">{{ 'MESSAGE_SCRREN_LATITUDE' | translate}}</label>
                <input [(ngModel)]="latitudModal" type="text" id="latitud">
            </div>
            <div class="input-row">
                <label  style="margin-right: 3px;" for="longitud">{{ 'MESSAGE_SCRREN_LONGITUDE' | translate}}</label>
                <input [(ngModel)]="longitudModal" type="text" id="longitud" >
            </div>
            <div class="input-row">
                <label  style="margin-right: 3px;" for="direccion">{{ 'MESSAGE_SCRREN_ADDRESS' | translate}}</label>
                <input [(ngModel)]="direccionModal" type="text" id="direccion" >
            </div>
        </div>
        <button class="custom-button"
            (click)="saveLocationData(latitudModal, longitudModal, direccionModal)">{{ 'MESSAGE_SCRREN_SEND' | translate}}</button>
    </div>
</div>